
function submitError(data) {
    try {
        fetch('/api?ajax_req=true&action=submit-error', { // use ajax_req so ajax request is forced and controller/model are automatically determined in FunnelExperience
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data)
        });
    } catch (e) {
        console.log("A network error has occurred");
    }
}

export function throwError(err, data = {}) {
    const msg = err.name + ': ' + err.message;

    data.stack = err.stack;
    data.message = msg;

    submitError(data);
}

export { submitError }